import { Overlay } from '@angular/cdk/overlay';
import { Injectable } from '@angular/core';

@Injectable()
export class ContextTooltipOverlay extends Overlay {}
